export default __webpack_public_path__ + "img/90ac56d505a882325bf17fe1500e3f9f.svg";